// utils/auth.js

export const saveToken = (token) => {
  if (token) localStorage.setItem("token", token);
};

export const getToken = () => localStorage.getItem("token");

export const removeToken = () => {
  localStorage.removeItem("token");
};

export const decodeToken = (token) => {
  if (!token || typeof token !== "string") {
    console.log("⚠️ decodeToken called with invalid token:", token);
    return null;
  }

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    const { exp, sub, ...rest } = payload;

    const now = Math.floor(Date.now() / 1000);

    if (!exp || exp <= now) {
      console.log("⏰ Token expired or invalid exp");
      return null;
    }

    return { ...rest, id: sub, exp };
  } catch (err) {
    console.log("❌ Failed to decode token:", err);
    return null;
  }
};